import { createBrowserRouter } from 'react-router';

import NotFound from './components/not-found';
import RouteErrorBoundary from './components/route-error-boundary';
import {
  AuthLayout,
  CourseLayout,
  LandingLayout,
  RootLayout,
  SidebarLayout,
  SolveLayout,
} from './layouts';
import {
  AssignmentDetailPage,
  CourseAssignmentsPage,
  CourseListPage,
  CourseNoticePage,
  ForgotPasswordPage,
  LandingPage,
  MyPage,
  MyPaymentsPage,
  NoticeDetailPage,
  PaymentFailPage,
  PaymentSuccessPage,
  RefundPolicyPage,
  ResetPasswordPage,
  SignInPage,
  SignUpPage,
  SolveAssignmentPage,
  TermsPage,
} from './pages';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      // Landing pages
      {
        element: <LandingLayout />,
        children: [
          {
            path: '/',
            element: <LandingPage />,
          },
        ],
      },

      // Auth pages
      {
        element: <AuthLayout />,
        children: [
          {
            path: '/sign-in',
            element: <SignInPage />,
          },
          {
            path: '/sign-up',
            element: <SignUpPage />,
          },
          {
            path: '/forgot-password',
            element: <ForgotPasswordPage />,
          },
          {
            path: '/reset-password',
            element: <ResetPasswordPage />,
          },
        ],
      },

      // Sidebar pages
      {
        element: <SidebarLayout />,
        children: [
          // Course list
          {
            path: '/course',
            element: <CourseListPage />,
          },

          // My page
          {
            path: '/my',
            element: <MyPage />,
          },

          // 내 결제/환불 내역
          {
            path: '/payment',
            element: <MyPaymentsPage />,
          },

          // Payment result pages (Toss 리다이렉트 랜딩)
          {
            path: '/payment/success',
            element: <PaymentSuccessPage />,
          },
          {
            path: '/payment/fail',
            element: <PaymentFailPage />,
          },

          // Course detail pages with tabs
          {
            element: <CourseLayout />,
            children: [
              {
                path: '/course/:courseId',
                element: <CourseAssignmentsPage />,
              },
              {
                path: '/course/:courseId/notice',
                element: <CourseNoticePage />,
              },
              {
                path: '/course/:courseId/notice/:noticeId',
                element: <NoticeDetailPage />,
              },
              {
                path: '/course/:courseId/:assignmentId',
                element: <AssignmentDetailPage />,
              },
            ],
          },
        ],
      },

      // Solve page (standalone layout - no sidebar, no course tabs)
      {
        element: <SolveLayout />,
        children: [
          {
            path: '/course/:courseId/:assignmentId/solve',
            element: <SolveAssignmentPage />,
          },
        ],
      },

      // Terms page (standalone)
      {
        path: '/terms',
        element: <TermsPage />,
      },

      // 취소·환불 정책 (전자결제 심사 요건상 독립 URL로 제공)
      {
        path: '/refund-policy',
        element: <RefundPolicyPage />,
      },
    ],
  },

  // 404 page
  {
    path: '*',
    element: <NotFound />,
  },
]);
